/**
 * Feature flags for enabling/disabling application features
 */
export const FEATURE_FLAGS = {
  /**
   * Enable address autocomplete functionality using OpenStreetMap Nominatim
   * Set to false to disable autocomplete suggestions in address forms
   */
  ENABLE_ADDRESS_AUTOCOMPLETE: false,
} as const;

export type FeatureFlags = typeof FEATURE_FLAGS;